module.exports = __webpack_public_path__ + "static/climate-156429594a2234ee06020b813840be0e.png";